import { render } from "./StockLocations.vue?vue&type=template&id=2b95b928&scoped=true"
import script from "./StockLocations.vue?vue&type=script&lang=js"
export * from "./StockLocations.vue?vue&type=script&lang=js"

import "./StockLocations.vue?vue&type=style&index=0&id=2b95b928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b95b928"]])

export default __exports__